import { AppLayout } from "../../layout/AppLayout/AppLayout";
import styles from "../../styles/time.module.css";

export const Time = () => (
  <AppLayout>
    <div className={styles["container"]}></div>
  </AppLayout>
);
